function PrePrints() {
    // const [number, setNumber] = useState(0);

    return (
      <>
        <div className="ml-10 mt-5">
          <div className="flex">
            <div className="w-1/6 text-center"></div>

            <div className="w-full">

              <div className="flex mt-2">
                    <div className="w-full">
                        <p><a href="https://arxiv.org/abs/2410.18877" target='_blank'>M. Kim, “PROPs associated to Lawvere theories and their relation to polynomial functors.”</a></p>
                        <p>arXiv preprint arXiv:2410.18877v2 (2026)</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-full">
                        <p><a href="https://arxiv.org/abs/2005.10621" target='_blank'>M. Kim, “On a pair of extensions of Mayer-Vietoris functors.”</a></p>
                        <p>arXiv preprint arXiv:2005.10621 (2022)</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-full">
                        <p><a href="https://arxiv.org/abs/2005.04652" target='_blank'>M. Kim, “Homology theory valued in the category of bicommutative Hopf algebras.”</a></p>
                        <p>arXiv preprint arXiv:2005.04652 (2020).</p>
                    </div>
                </div>
                
                <div className="flex mt-2 hidden">
                    <div className="w-full">
                        <p>M. Kim, “A categorification of the eigen-ring construction.”</p>
                        <p>in preparation.</p>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  
  export default PrePrints;